var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length > 0)?_c('div',_vm._l((_vm.items),function(item,i){return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(item.actor + '@' + item.permission),expression:"item.actor + '@' + item.permission"}],key:i,staticClass:"is-inline-block"},[_vm._v("\n    "+_vm._s(item.actor)+"\n  ")])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70cc8421","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wallet/tx/Auth.vue
// module id = null
// module chunks = 